import { TextInput } from "@hoylu/client-common";
import React from "react";
import { useTextInputLocalization } from "../../../utils/useTextInputLocalization";
import Styles from "./PasswordInput.module.css";

type PasswordInputProps = {
  password: string;
  passwordOnChange: (value: string) => void;
  placeholder: string;
  label?: string;
};

export const PasswordInput: React.FC<PasswordInputProps> = ({
  password,
  passwordOnChange,
  placeholder,
  label = "",
}) => {
  const localizationDict = useTextInputLocalization();
  return (
    <TextInput
      classNames={[Styles.passwordInput]}
      label={label}
      localizationDict={localizationDict}
      onChange={passwordOnChange}
      type="password"
      useTogglePassword={true}
      value={password}
      watermark={placeholder}
    />
  );
};
